<template>
    <v-row class="justify-center align-center forget-password mx-0">
        <v-card class="form-card">
            <div class="spacer p20"></div>
            <div class="spacer p20"></div>
            <div class="spacer p20"></div>
            <h1>{{ metaData.header }}</h1>
            <div class="spacer p20"></div>
            <div class="spacer p20"></div>

            <v-row class="justify-center">
                <div class="row-content">
                    <v-alert type="success" v-if="successMessage">
                        {{ successMessage }}
                    </v-alert>
                    <v-alert type="error" v-if="errorMessage">
                        {{ errorMessage }}
                    </v-alert>
                </div>
            </v-row>
            <v-form v-model="model.valid" v-if="isValidHash">
                <v-row class="justify-center">
                    <div class="row-content">
                        <v-text-field
                                label="Пароль"
                                required
                                v-model="model.password"
                                :type="passwordFieldType"
                                :append-icon="passwordIcon"
                                v-on:click:append="passwordVisibility"
                                :rules="rules.password"
                                color="orange lighten-2"
                        >
                        </v-text-field>
                    </div>
                </v-row>
                <div class="spacer p20"></div>
                <div class="spacer p20"></div>
                <v-row class="justify-center">
                    <div class="row-content">
                        <v-btn
                                rounded
                                width="100%"
                                class="main--yellow white--text"
                                :disabled="!model.valid"
                                @click="sendData"
                                elevation="0"
                        >
                            {{ $t('savePassword') }}
                        </v-btn>
                    </div>
                </v-row>
            </v-form>
        </v-card>
    </v-row>
</template>

<script>
    import AuthService from '../../../app-front/services/api/AuthService';

    export default {
        name: "ResetPasswordNew",
        props:['hash'],
        data(){
            return {
                errorMessage: '',
                isPasswordVisible: false,
                isValidHash: false,
                metaUrl: '/reset-password',
                model: {
                    valid: false,
                    password: '',
                    email: '',
                    token: ''
                },
                rules: {
                    password: [
                        v => !!v || this.$t('passwordRequired')
                    ]
                },
                successMessage: '',
            }
        },
        computed: {
            passwordIcon() {
                return this.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye';
            },
            passwordFieldType() {
                return this.isPasswordVisible ? 'text' : 'password';
            }
        },
        methods: {
            checkHash(){
                AuthService.checkHash(this.hash)
                    .then(res => {
                        if(res.data.error) {
                            this.errorMessage = res.data.error;
                        } else {
                            this.model.email = res.data.email;
                            this.model.token = res.data.token;
                            this.isValidHash = true;
                        }
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
            },
            passwordVisibility() {
                this.isPasswordVisible = !this.isPasswordVisible
            },
            sendData() {
                const credentials = {
                    email: this.model.email,
                    password: this.model.password,
                    c_password: this.model.password,
                    token: this.model.token
                };

                AuthService.resetPassword(credentials)
                    .then(res => {
                        if(res.data.error) {
                            this.errorMessage = res.data.error;

                            setTimeout(() => {
                                this.errorMessage = '';
                            }, 2000);
                        }

                        if(res.data.success) {
                            this.successResetHandle(res.data.success);
                        }
                    })
                    .catch(err => {
                        this.errorMessage = $t('resetPasswordError');
                    });
            },
            successResetHandle(data) {
                this.successMessage = data.message;

                setTimeout(() => {
                    this.initLogin(data.token);
                    this.$router.push('/');
                }, 3000);
            }

        },
        beforeMount() {
            this.checkHash();
        }
    }
</script>

<style scoped>

</style>
